export default __webpack_public_path__ + "0596d5aef6b401e7afc2383312604669.png";